var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrdersEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M220.134 0H80C28.9334 0 0 28.9334 0 80V220.001C0 271.066 28.9334 300 80 300H220.134C271.2 300 300 271.066 300 220.001V80C300 28.9334 271.2 0 220.134 0Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.43 217.1C102.43 210.537 107.742 205.225 114.305 205.225C120.789 205.225 126.102 210.537 126.102 217.1C126.102 223.584 120.789 228.896 114.305 228.896C107.742 228.896 102.43 223.584 102.43 217.1ZM190.32 217.1C190.32 210.537 195.633 205.225 202.195 205.225C208.68 205.225 213.992 210.537 213.992 217.1C213.992 223.584 208.68 228.896 202.195 228.896C195.633 228.896 190.32 223.584 190.32 217.1Z",
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.99 105.851C218.756 105.851 221.881 107.492 225.006 111.086C228.131 114.679 228.678 119.836 227.975 124.515L220.553 175.765C219.146 185.617 210.709 192.875 200.787 192.875H115.553C105.162 192.875 96.5683 184.906 95.7089 174.601L88.5214 89.4372L76.7245 87.4059C73.5995 86.859 71.412 83.8122 71.9589 80.6872C72.5058 77.484 75.5527 75.3747 78.7558 75.8434L97.3886 78.6559C100.045 79.1325 101.998 81.3122 102.232 83.9684L103.717 101.468C103.951 103.976 105.982 105.851 108.482 105.851H213.99ZM166.646 146.468H188.287C191.568 146.468 194.146 143.812 194.146 140.609C194.146 137.328 191.568 134.75 188.287 134.75H166.646C163.365 134.75 160.787 137.328 160.787 140.609C160.787 143.812 163.365 146.468 166.646 146.468Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersEmpty);
export default __webpack_public_path__ + "static/media/ordersEmpty.75bcb9cabaf7f9d51d21d87feee0f0f5.svg";
export { ForwardRef as ReactComponent };